var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row justify-content-center" }, [
    _c("div", { staticClass: "col-12" }, [
      _c(
        "div",
        { staticClass: "card card-header" },
        [
          _vm.loading
            ? _c("calendar-loader")
            : [
                _vm.syncedEmail.allIds.length
                  ? _c(
                      "div",
                      {
                        staticClass: "position-relative",
                        attrs: { id: "task-calendar-wrapper" },
                      },
                      [
                        _vm.refreshingEvents
                          ? _c("inline-loader", {
                              staticStyle: {
                                position: "absolute",
                                right: "0",
                                top: "0",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("full-calendar", {
                          ref: "calendar",
                          attrs: {
                            id: "task-calendar-container",
                            options: _vm.calendarOptions,
                          },
                        }),
                      ],
                      1
                    )
                  : _c("div", { attrs: { id: "task-calendar-wrapper" } }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex justify-content-center align-items-center flex-row w-100 h-100",
                        },
                        [
                          _c("div", { staticClass: "text-center" }, [
                            _c(
                              "span",
                              { staticClass: "missing-field-icon-wrapper" },
                              [
                                _c("img", {
                                  attrs: {
                                    src: _vm.noCalendarImg,
                                    alt: _vm.$t("global.words.missingCalendar"),
                                  },
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "row",
                                attrs: {
                                  id: "dashboard-sync-email-video-tooltip",
                                },
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass: "font-sm text-light-gray mb-0",
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t(
                                            "dashboard.messages.errors.noEmailsConnected"
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("icon", {
                                  staticClass: "tooltip-info",
                                  attrs: { name: "question-circle" },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              { staticClass: "font-sm text-light-gray" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t("dashboard.calendar.letUsExplain")
                                    ) +
                                    "!\n              "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass: "btn btn-primary",
                                on: { click: _vm.goToSettings },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("dashboard.calendar.syncCalendar")
                                  )
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                _vm._v(" "),
                _c("meetings-modal", {
                  ref: "meetingModal",
                  attrs: { "synced-emails": _vm.syncedEmail.emails },
                  on: { select: _vm.initiateNylas },
                }),
                _vm._v(" "),
                _c("schedule-modal", {
                  attrs: { "should-display": _vm.shouldDisplayScheduler },
                }),
                _vm._v(" "),
                _c("calendar-popover", {
                  ref: "calendarPopover",
                  attrs: {
                    loading: _vm.loadingCalendarEvent,
                    "event-click-obj": _vm.eventObj,
                    "event-details": _vm.eventInfo,
                  },
                  on: { hidden: _vm.handleHidden },
                }),
              ],
          _vm._v(" "),
          _vm.syncedEmail.allIds.length
            ? _c(
                "div",
                { staticClass: "text-right small" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "clickable text-primary",
                      attrs: { id: "gmail-disclosure" },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("dashboard.calendar.gmailDisclosure")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-tooltip",
                    {
                      attrs: { target: "gmail-disclosure", triggers: "hover" },
                    },
                    [
                      _c("i18n", {
                        staticClass: "font-sm mb-0",
                        attrs: {
                          path: "settings.accountTab.googleApiMessage",
                          tag: "p",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "note",
                              fn: function () {
                                return [
                                  _c(
                                    "span",
                                    { staticClass: "bold text-capitalize" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$tc("global.words.note", 1)
                                        ) + ":\n              "
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "policyLink",
                              fn: function () {
                                return [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        href: "https://developers.google.com/terms/api-services-user-data-policy#additional_requirements_for_specific_api_scopes",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "settings.accountTab.googleApiDataPolicy"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          4219347829
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }